export const intent_labels = {
  /** Dashboard */
  open_dashboard: 'dashboard_open',
  open_edit_dashboard: 'dashboard_edit_open',
  create_dashboard: 'dashboard_create',
  update_dashboard: 'dashboard_update',

  /** Calendar */
  open_calendar_screen: 'calendar_screen_open',
  open_create_calendar_item_screen: 'calendar_new_open',
  open_edit_calendar_item_screen: 'calendar_edit_open',
  event_start: 'calendar_event_start',
  event_end: 'calendar_event_end',

  /** Contacts */
  open_contacts_screen: 'contacts_screen_open',
  open_create_contact_screen: 'contacts_new_open',
  open_edit_contact_screen: 'contacts_edit_open',
  create_contact: 'contacts_new_create',
  update_contact: 'contacts_contact_update',
  delete_contact: 'contacts_contact_delete',
  favourite_contact: 'contacts_contact_favourite',
  call_contact: 'contacts_contact_call',

  /** Goals */
  open_goals_screen: 'goals_screen_open',
  open_create_goal_screen: 'goals_new_open',
  create_goal: 'goals_new_create',
  update_goal: 'goals_goal_update',
  delete_goal: 'goals_goal_delete',
  open_edit_goal_screen: 'goals_edit_open',
  open_goal_statistics_screen: 'goals_statistics_open',

  /** Checklists */
  open_checklists_screen: 'checklists_screen_open',
  open_create_checklist_screen: 'checklists_new_open',
  open_edit_checklist_screen: 'checklists_edit_open',

  /** Meals */
  open_meals: 'meals_screen_open',
  open_recipe_search_screen: 'recipes_screen_open',
  open_recipe: 'recipes_recipe_open',
  favourite_recipe: 'recipes_recipe_favourite',

  /** Apps */
  open_apps_screen: 'apps_screen_open',
  open_app: 'apps_app_open',

  ping_five_minutes: 'ping_five_minutes',
};
